<script lang="ts">
    import { _ } from 'svelte-i18n';

    import type { WidgetTemplateResponseType } from '../WidgetTemplateApi';
    import Checkbox from '../../Checkbox/Checkbox.svelte';
    import { WidgetTemplateList } from './WidgetTemplateList';
    import InputTextInline from '../../InputTextInline.svelte';
    import MenuContextIcon from '../../../components/MenuDropdown/MenuContext/MenuContextIcon.svelte';
    import { MenuContextCustomActions } from '../../../components/MenuDropdown/MenuContextCustomActions';
    import IconRemove from '../../Icons/IconRemove.svelte';
    import IconPending from '../../Icons/IconPending.svelte';
    import IconStylus from '../../Icons/IconStylus.svelte';
    import LinkSmallBlack from '../../LinkSmallBlack.svelte';
    import { app } from '../../../../stores/app';
    import IconDot from '../../Icons/IconDot.svelte';

    export let template: WidgetTemplateResponseType;
    export let currentId: number | null;
    export let onSelect: (templateId: number) => void;
    export let onChange: (templates: WidgetTemplateResponseType[]) => void;
    export let widgetTemplateList: WidgetTemplateList;
    export let showHeader: boolean = false;

    let checkboxSaving: boolean = false;
    let inputSaving: boolean = false;
    let inputEditMode: boolean = false;

    let removingItem: boolean = false;

    let menu: MenuContextCustomActions = new MenuContextCustomActions();

    function updateMenu(menu: MenuContextCustomActions) {
        menu.reset();
        menu.addAction({
            id: 'edit_label',
            label: $_('rename_action'),
            disabled: template.webuser_id !== $app.account.getWebuserId(),
            visible: true,
            icon: IconStylus,
            onClick: () => {
                console.log('Edit', template.id);
                inputEditMode = true;
            },
            subMenuIsOpen: false,
            visibleInContextMenu: true,
        });
        menu.addAction({
            id: 'remove',
            label: $_('remove_view'),
            disabled: template.webuser_id !== $app.account.getWebuserId(),
            visible: true,
            icon: IconRemove,
            onClick: () => {
                console.log('Remove', template.id);
                removingItem = true;
                widgetTemplateList
                    .removeTemplate(template.id)
                    .then(_ => {
                        widgetTemplateList
                            .load()
                            .then(_ => {
                                console.log(
                                    'Remove, after load',
                                    widgetTemplateList.getTemplates().map(t => t.label)
                                );
                                widgetTemplateList = widgetTemplateList;
                            })
                            .finally(() => {
                                removingItem = false;
                                onChange(widgetTemplateList.getTemplates());
                            });
                    })
                    .finally(() => {
                        removingItem = false;
                    });
            },
            subMenuIsOpen: false,
            visibleInContextMenu: true,
        });
        menu = menu;
    }

    updateMenu(menu);
</script>

{#if showHeader}
    <div class="job-element job-element-header">
        <div class="icon"></div>
        <div class="name dont-break">{$_('Nazwa')}</div>
        <div class="author dont-break">{$_('Autor')}</div>
        <div class="status dont-break">{$_('visibility')}</div>
        <div class="actions"></div>
    </div>
{/if}

<div
    class="job-element job-element-data"
    class:active={currentId === template.id}
    class:unavailable={removingItem}
>
    <div class="icon">
        {#if currentId === template.id}
            <!--            <IconCheck scale={0.7} />-->
            <IconDot scale={0.5} />
        {/if}
    </div>
    <div
        class="name dont-break"
        title={template.label}
        on:click={() => {
            if (inputEditMode) {
                console.log('inputEditMode', inputEditMode);
                return false;
            }
            onSelect(template.id);
        }}
    >
        {#if inputEditMode}
            <InputTextInline
                value={template.label}
                disabled={inputSaving}
                editMode={true}
                showEditIcon={false}
                styleMode="blue"
                onChange={label => {
                    console.log('label', label);
                    inputSaving = true;
                    template = { ...template, label: label.toString() };
                    widgetTemplateList
                        .modifyTemplate(template)
                        .then(_ => {
                            console.log('Checkbox, template saved', template);
                        })
                        .finally(() => {
                            inputSaving = false;
                            inputEditMode = false;
                            onChange(widgetTemplateList.getTemplates());
                        });
                }}
            />
        {:else}
            {template.label}
        {/if}
    </div>
    <div class="author dont-break" title={template.webuser_id?.toString() || 'webuserId is undefined'}>
        {#if template.webuser_id === $app.account.getWebuserId()}
            ({$_('Ja')})
        {:else}
            {template.webuser_name}
        {/if}
    </div>
    <div class="status dont-break">
        {#if template.webuser_id === $app.account.getWebuserId()}
            {#if checkboxSaving}
                <IconPending scale={0.7} spin={true} />
            {:else if template.user_private === false}
                <Checkbox
                    disabled={checkboxSaving}
                    checked={true}
                    onChange={checked => {
                        console.log('Checkbox', checked);
                        checkboxSaving = true;
                        template = { ...template, user_private: true };
                        widgetTemplateList
                            .modifyTemplate(template)
                            .then(_ => {
                                console.log('Checkbox, template saved', template.user_private);
                            })
                            .finally(() => {
                                checkboxSaving = false;
                                widgetTemplateList = widgetTemplateList;
                                onChange(widgetTemplateList.getTemplates());
                            });
                    }}
                    label={$_("Udostępniony do odczytu")}
                />
            {:else}
                <LinkSmallBlack
                    text={$_('share_read_only')}
                    on:click={() => {
                        console.log('Udostępnij');
                        checkboxSaving = true;
                        template = { ...template, user_private: false };
                        widgetTemplateList
                            .modifyTemplate(template)
                            .then(_ => {
                                console.log('Udostępnij, user_private', template.user_private);
                            })
                            .finally(() => {
                                checkboxSaving = false;
                                onChange(widgetTemplateList.getTemplates());
                            });
                    }}
                />
            {/if}
        {:else if template.user_private}
            <span>{$_('Prywatny')}</span>
        {:else}
            <span>{$_('shared_label')}</span>
        {/if}
    </div>
    <div class="actions">
        {#if removingItem}
            <IconPending scale={0.7} spin={true} />
        {:else}
            <MenuContextIcon bind:menu />
        {/if}
    </div>
</div>

<!--{/if}-->

<style>
    .job-element {
        box-sizing: border-box;
        display: grid;
        grid-template-columns: 30px 1fr 16% 35% 30px;
        grid-template-rows: var(--medium-row-height);
        gap: 0 0;
        border-bottom: 1px solid #2222;
        grid-template-areas: 'icon name author status actions';
    }

    .job-element {
        background-color: #f5f5f0;
    }

    .job-element:first-of-type {
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
    }

    .job-element:last-child {
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
    }

    .job-element-header > div {
        font-weight: 200;
        text-transform: uppercase;
        font-size: 12px;
        opacity: 0.8;
    }

    /*.job-element.active {*/
    /*    background-color: #6c6b6a;*/
    /*    color: white;*/
    /*}*/

    .job-element-data:hover,
    .job-element-data.active:hover {
        background-color: var(--main-selected-background);
        color: unset;
        cursor: pointer;
    }

    .job-element .name,
    .job-element .author,
    .job-element .status {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        /*padding: 0 5px;*/
    }

    .job-element-data .name {
        font-weight: 500;
    }

    .job-element-data .author {
        font-size: 12px;
        font-weight: 300;
    }
    .job-element-data .status {
        font-size: 12px;
    }

    .job-element .icon,
    .job-element .actions {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .active {
        grid-area: active;
    }
    .unavailable {
        opacity: 0.5;
        pointer-events: none;
    }

    .status {
        grid-area: status;
    }

    .name {
        grid-area: name;
    }
</style>
